import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { triggerHaptic } from '../../utils/haptics';

const SwipeNavigation = ({ children }) => {
  const navigate = useNavigate();
  const [startX, setStartX] = useState(null);
  
  const SWIPE_THRESHOLD = 80; // pixels
  const EDGE_ZONE = 40; // Only trigger if swipe starts within 40px of left edge

  useEffect(() => {
    const handleTouchStart = (e) => {
      const touchX = e.touches[0].clientX;
      // Only record start if touch is on the far left edge of the screen
      if (touchX < EDGE_ZONE) {
        setStartX(touchX);
      }
    };

    const handleTouchMove = (e) => {
      // Intentionally passive, but we could add visual dragging indicator here
    };

    const handleTouchEnd = (e) => {
      if (startX === null) return;
      
      const touchEndX = e.changedTouches[0].clientX;
      const diffX = touchEndX - startX;

      // If user swiped right from the edge far enough, trigger native back
      if (diffX > SWIPE_THRESHOLD) {
        triggerHaptic.medium();
        navigate(-1);
      }
      
      setStartX(null);
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [startX, navigate]);

  return <>{children}</>;
};

export default SwipeNavigation;
